"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerColorField = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../../../theme/utils/useTheme");
var _colorUtilities = require("../../../colorPickerUtils/colorUtilities");
var _constrainValue = require("../../../colorPickerUtils/constrainValue");
var _ColorFieldIndicator = require("./styled/ColorFieldIndicator");
var _ColorPickerColorFieldRoot = require("./styled/ColorPickerColorFieldRoot");
const ColorPickerColorField = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    h,
    s,
    l,
    onChange,
    className,
    clientId
  } = _ref;
  const fieldRef = (0, _react.useRef)(null);
  const combinedRef = (0, _lodestarUtils.useForkRef)(fieldRef, ref);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const getMousePosition = e => {
    const currentField = fieldRef.current;
    if (currentField) {
      const fieldRect = currentField.getBoundingClientRect();
      const x = (e.clientX - fieldRect.left) / fieldRect.width;
      const y = (e.clientY - fieldRect.top) / fieldRect.height;
      return {
        x,
        y
      };
    }
  };
  const onMouseDown = e => {
    onMouseMove(e);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", cleanUp);
  };
  const onMouseMove = (0, _react.useCallback)(e => {
    const mousePosition = getMousePosition(e);
    if (mousePosition) {
      let {
        x,
        y
      } = mousePosition;
      x = (0, _constrainValue.constrainValue)(0, 1, x);
      y = (0, _constrainValue.constrainValue)(0, 1, y);
      onChange((0, _colorUtilities.hsv2hsl)(h, x, 1 - y));
    }
  }, [h, onChange]);

  // TODO dry this up
  const onKeyDown = e => {
    let newv, news;
    const hsv = (0, _colorUtilities.hsl2hsv)(h, s, l);
    switch (e.key) {
      case "ArrowUp":
        e.preventDefault();
        newv = (0, _constrainValue.constrainValue)(0, 1, hsv.v + (e.shiftKey ? 0.05 : 0.01));
        onChange((0, _colorUtilities.hsv2hsl)(hsv.h, hsv.s, newv));
        break;
      case "ArrowDown":
        e.preventDefault();
        newv = (0, _constrainValue.constrainValue)(0, 1, hsv.v - (e.shiftKey ? 0.05 : 0.01));
        onChange((0, _colorUtilities.hsv2hsl)(hsv.h, hsv.s, newv));
        break;
      case "ArrowRight":
        e.preventDefault();
        news = (0, _constrainValue.constrainValue)(0, 1, hsv.s + (e.shiftKey ? 0.05 : 0.01));
        onChange((0, _colorUtilities.hsv2hsl)(hsv.h, news, hsv.v));
        break;
      case "ArrowLeft":
        e.preventDefault();
        news = (0, _constrainValue.constrainValue)(0, 1, hsv.s - (e.shiftKey ? 0.05 : 0.01));
        onChange((0, _colorUtilities.hsv2hsl)(hsv.h, news, hsv.v));
        break;
      default:
        return e;
    }
  };
  const cleanUp = (0, _react.useCallback)(() => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", cleanUp);
  }, [onMouseMove]);
  (0, _react.useEffect)(() => {
    return cleanUp();
  }, [cleanUp]);
  (0, _react.useEffect)(() => {
    fieldRef.current?.focus();
  }, [fieldRef]);
  const hsv = (0, _colorUtilities.hsl2hsv)(h, s, l);
  const indicatorStyle = {
    bottom: `${hsv.v * 100}%`,
    left: `${hsv.s * 100}%`
  };
  return /*#__PURE__*/_react.default.createElement(_ColorPickerColorFieldRoot.ColorPickerColorFieldRoot, {
    style: {
      backgroundColor: `hsl(${h}, 100%, 50%)`
    },
    className: className,
    onMouseDown: onMouseDown,
    ref: combinedRef,
    tabIndex: -1,
    onKeyDown: onKeyDown,
    "data-client-id": clientId,
    draggable: false,
    "aria-hidden": true,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(_ColorFieldIndicator.ColorFieldIndicator, {
    style: indicatorStyle,
    draggable: false
  }));
});
exports.ColorPickerColorField = ColorPickerColorField;
ColorPickerColorField.displayName = "ColorPickerColorField";
//# sourceMappingURL=ColorPickerColorField.js.map